import React from "react"
import { SketchPicker } from 'react-color';
import { Input, Button, Table, Space, Select, Form, DatePicker } from 'antd'
import { FormInstance } from "antd/lib/form"
import Modal from "antd/lib/modal/Modal"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import axios, { axiosTable } from '../../tool/axios'
import BreadCrumb from '../../component/BreadCrumb'
import { formItemLayout, tailLayout } from '../../js/globalParam'

const { Column } = Table
const { Option } = Select

interface State {
    data: object[],
    loading: boolean,
    type: string | null,
    pagination: {
        current: number,
        pageSize: number,
        total: number
    },
    item: any,
    fetchOtherParams: {
        store_name: string | null,
        item_type: string | null,
        flag_name: string | null,
        item_name: string | null,
        item_status: string | null
    },
    formParams: {
        item_type: string | null
    },
    offShelfVisible: boolean,
    addVisible: false
}

export default class TagList extends React.Component {
    state: State = {
        data: [],
        loading: false,
        type: 'add',
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0
        },
        item: {
            flag_type: null,
            flag_name: null,
            flag_color: '',
        },
        fetchOtherParams: {
            item_type: null,
            item_name: null,
            flag_name: null,
            store_name: null,
            item_status: null
        },
        formParams: {
            item_type: null
        },
        offShelfVisible: false,
        addVisible: false
    }
    formRef = React.createRef<FormInstance>()

    confirmAdd() {
        let { item } = this.state;
        let current: any = this.formRef.current;
        let obj: object | any = {}
        let url: string = ''

        for (let i in item) {
            if (i == 'flag_color' && typeof current.getFieldValue(i) != 'string') {
                obj[i] = current.getFieldValue(i).hex

            } else {
                obj[i] = current.getFieldValue(i)
            }
        }

        if (obj.id) {
            url = '/manage_center/flag/update'
        } else {
            url = '/manage_center/flag/add'
        }

        axios.post(url, obj).then(() => {
            const { pagination, fetchOtherParams } = this.state
            this.fetch({ pagination, fetchOtherParams })
            this.closeModal()
        })
    }

    confirmOffShelf() {

    }

    offShelf() {
        this.setState({ offShelfVisible: true })
    }

    componentDidMount() {
        const { pagination, fetchOtherParams } = this.state
        this.fetch({ pagination, fetchOtherParams })
    }

    handleInputChange(e: any) {
        let { fetchOtherParams } = this.state
        fetchOtherParams.flag_name = e.target.value

        this.setState({ fetchOtherParams })
    }

    handleInputChange2(e: any) {
        let { fetchOtherParams } = this.state
        fetchOtherParams.item_name = e.target.value

        this.setState({ fetchOtherParams })
    }

    handleColorChange = (colorCode: any) => {
        let { item } = this.state
        item.flag_color = colorCode.hex

        this.setState({ item })
    }

    handleSelectChange1(value: string) {
        let { item } = this.state;
        item.flag_type = value

        this.setState({
            item
        })
    }

    selectState(type: string) {
        let { pagination, fetchOtherParams } = this.state;

        if (type != 'current') {
            pagination.current = 1;
        }

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    handleTableChange = (antPagination: any) => {
        const { fetchOtherParams, pagination } = this.state
        pagination.current = antPagination.current
        pagination.pageSize = antPagination.pageSize

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    fetch({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/manage_center/flag/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            const { pagination } = this.state
            pagination.total = response.total
            pagination.pageSize = response.size
            pagination.current = response.current

            this.setState({
                pagination,
                data: response.records
            })
        })
    }

    resetForm() {
        let { fetchOtherParams } = this.state
        fetchOtherParams.flag_name = null

        this.setState({ fetchOtherParams })
        this.selectState('')
    }

    closeModal() {
        for (let i in this.state.item) {
            this.formRef.current?.setFieldsValue({ [i]: '' })
        }

        this.setState({
            addVisible: false,
            item: { flag_type: null, flag_name: null, flag_color: '' }
        })
    }

    reviewDetail(item: object | any) {
        this.setState({
            item,
            type: 'edit',
            addVisible: true
        })

        this.setState({ addVisible: true }, () => {
            for (let i in item) {
                this.formRef.current?.setFieldsValue({ [i]: item[i] })
            }
        })
    }

    render() {
        let { store_name, item_name, flag_name } = this.state.fetchOtherParams
        let newflag = [{ id: 1, key: 1, item_name: '项目' }, { id: 2, key: 3, item_name: '门店' }, { id: 3, key: 3, item_name: '员工' }]
        let flagType = newflag.map((el: any) => (<Option value={el.id} key={el.id}>{el.item_name}</Option>))

        return (<div className="common-page">
            {/* 管理中心 -> 标签管理 -> 项目标签管理 */}
            <BreadCrumb position={['管理中心', '项目标签管理']} />

            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="标签名称" value={flag_name === null ? '' : flag_name} onChange={this.handleInputChange.bind(this)} />

                    <Button style={{ marginRight: 5, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={this.selectState.bind(this, '')} >查询</Button>
                    <Button style={{ marginRight: 5, marginBottom: 12 }} onClick={this.resetForm.bind(this)} icon={<RedoOutlined />}>重置</Button>
                    <Button style={{ marginRight: 5, marginBottom: 12 }} type="primary" onClick={() => { this.setState({ addVisible: true, type: 'add' }) }}>添加</Button>
                </Space>
            </div>

            <div className="common-main">
                <Table dataSource={this.state.data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={this.state.pagination} onChange={this.handleTableChange.bind(this)}>
                    <Column title="标签名称" dataIndex="flag_name" key="flag_name" />
                    <Column title="标签类型" dataIndex="flag_type" key="flag_type" render={(value: number): string => value === 1 ? '项目' : (value === 2 ? '门店' : '员工')} />
                    <Column title="创建时间" dataIndex="create_date" key="create_date" />

                    <Column
                        title="操作"
                        key="action"
                        render={(text, record) => (
                            <Space size="middle">
                                <Button type="primary" onClick={this.reviewDetail.bind(this, record)}>查看</Button>
                            </Space>
                        )}
                    />
                </Table>
            </div>

            <Modal title={this.state.type == 'edit' ? "编辑标签" : "新增标签"} visible={this.state.addVisible} footer={false} width="600px" onCancel={this.closeModal.bind(this)}>
                <Form name="validate_other" ref={this.formRef} {...formItemLayout} onFinish={this.confirmAdd.bind(this)} >
                    <Form.Item label="标签名称" name="flag_name"
                        rules={[{ required: true, message: '必须填写标签名称' }, () => ({
                            validator(_, value) {
                                if (/^[A-Za-z0-9\u4e00-\u9fa5]+$/.test(value)) {
                                    return Promise.resolve();
                                }

                                return Promise.reject(new Error('不能输入特殊符号和空格'));
                            },
                        })]}>
                        <Input placeholder="标签名称" />
                    </Form.Item>

                    <Form.Item label="标签类型" name="flag_type" rules={[{ required: true, message: '必须选择标签类型' }]}>
                        <Select placeholder="标签类型">
                            {flagType}
                        </Select>
                    </Form.Item>

                    <Form.Item label="标签颜色" name="flag_color">
                        <SketchPicker color={this.state.item.flag_color as any} onChange={this.handleColorChange} />
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Button type="primary" htmlType="submit">提交</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>)
    }
}